import React, { useState, useEffect } from 'react';
import CommonModal from './CommonModal';

function ApprovalOpinionModal({ show, onClose, onConfirm, actionLabel }) {
  const [opinion, setOpinion] = useState("");

  // 모달 열릴 때마다 의견 초기화
  useEffect(() => {
    if (show) {
      setOpinion("");
    }
  }, [show]);

  if (!show) return null;

  return (
    <CommonModal title="📝 결재 의견 작성" onClose={onClose} size="md">
      <textarea
        className="form-control mt-2"
        rows="4"
        value={opinion}
        onChange={(e) => setOpinion(e.target.value)}
        placeholder="결재 의견을 입력하세요..."
      />
      <div className="mt-3 d-flex justify-content-end">
        <button
          className="btn btn-primary me-2"
          onClick={() => {
            onConfirm(opinion);   // ✅ 입력한 의견을 부모로 전달
            setOpinion("");
          }}
        >
          {actionLabel || "확인"}
        </button>

        <button className="btn btn-secondary" onClick={onClose}>
          취소
        </button>
      </div>
    </CommonModal>
  );
}

export default ApprovalOpinionModal;